import { RouteObject } from 'react-router-dom';
import userAuthRoutes from './auth';
import userDashboardRoutes from './dashboard';

export const userRoutes: RouteObject[] = [...userDashboardRoutes, ...userAuthRoutes];
